import React, { useEffect, useRef, useState } from "react";
import { Card } from "react-bootstrap";

import ProductPicker from "./ProductPicker";

function AddProductInput({ existingProductsIds, onSubmit, onCancel }) {
  const [productId, setProductId] = useState(null);

  const selectRef = useRef();

  const productAdditionConfirmed = () => {
    if (productId !== null) {
      onSubmit(productId);
    }
  };

  const productPickerKeyDown = (e) => {
    if (e.key === "Enter" && selectRef.current.state.inputIsHidden) {
      if (productId !== null) {
        onSubmit(productId);
      }
    } else if (e.key === "Escape") {
      onCancel();
    }
  };

  useEffect(() => {
    if (selectRef.current) {
      selectRef.current.focus();
    }
  }, []);

  return (
    <div className="col col-12">
      <Card className="p-2 d-flex flex-row h-100 align-items-center">
        <ProductPicker
          onProductPicked={setProductId}
          onKeyDown={productPickerKeyDown}
          productsIdsToExclude={existingProductsIds}
          selectRef={selectRef}
        />
        <button type="button" className="btn btn-primary" onClick={productAdditionConfirmed}>
          Add
        </button>
      </Card>
    </div>
  );
}

export default AddProductInput;
